import React from 'react'

interface FilterIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const FilterIcon: React.FC<FilterIconProps> = ({
  color = '#000',
  gradient,
  width = 24,
  height = 21,
  alt = 'Filter icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 24 21'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M7.07 3.29H24v-1.2H7.02a2.036 2.036 0 01.05 1.2zm-4.407 0a2.038 2.038 0 01.05-1.2H0v1.2h2.663zM11.131 18.093H24v-1.2H11.139a2.064 2.064 0 01-.008 1.2zm-4.287 0a2.065 2.065 0 01-.007-1.2H0v1.2h6.844z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M5.156 1.25c-.915 0-1.611.705-1.611 1.52 0 .816.696 1.52 1.61 1.52.915 0 1.612-.704 1.612-1.52 0-.815-.697-1.52-1.611-1.52zM2.295 2.77C2.295 1.216 3.6 0 5.155 0c1.556 0 2.862 1.216 2.862 2.77S6.71 5.54 5.156 5.54c-1.556 0-2.861-1.216-2.861-2.77zM19.436 10.738H24v-1.2h-4.557a2.068 2.068 0 01-.007 1.2zm-4.287 0a2.064 2.064 0 01-.007-1.2H0v1.2h15.149zM8.988 15.96c-.914 0-1.611.705-1.611 1.52 0 .816.697 1.52 1.61 1.52.915 0 1.612-.704 1.612-1.52 0-.815-.697-1.52-1.611-1.52zm-2.861 1.52c0-1.554 1.305-2.77 2.86-2.77 1.556 0 2.862 1.216 2.862 2.77s-1.306 2.77-2.861 2.77c-1.556 0-2.861-1.216-2.861-2.77z'
        clipRule='evenodd'
      />
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M17.293 8.605c-.915 0-1.611.705-1.611 1.52 0 .816.696 1.52 1.61 1.52.915 0 1.611-.704 1.611-1.52 0-.815-.696-1.52-1.61-1.52zm-2.861 1.52c0-1.553 1.305-2.77 2.86-2.77 1.556 0 2.861 1.217 2.861 2.77 0 1.555-1.305 2.77-2.86 2.77-1.556 0-2.861-1.215-2.861-2.77z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FilterIcon
